export const DURATION_UNITS = {
  MINUTES: 'minutos',
  HOURS: 'horas',
  DAYS: 'dias',
};
